import { createError } from '#app/composables/error';
import { ErrorCodes, getErrorStatusCode, hasErrorCode } from '#layers/base/public';
import { readLastWorkspace, writeLastWorkspace } from '#layers/workspace/public';

export function rememberWorkspace({
	userId,
	workspaceSlug,
}: { userId: string | undefined; workspaceSlug: string }) {
	if (userId && readLastWorkspace(userId) !== workspaceSlug) writeLastWorkspace(userId, workspaceSlug);
}

export function toWorkspaceSwitchError({ error, noAccessMessage }: { error: unknown; noAccessMessage: string }) {
	if (!hasErrorCode(error, ErrorCodes.WORKSPACE_ACCESS_DENIED) && getErrorStatusCode(error) !== 403) return error;

	return createError({
		statusCode: 403,
		statusMessage: noAccessMessage,
		data: { code: ErrorCodes.WORKSPACE_ACCESS_DENIED },
	});
}
